export default __webpack_public_path__ + "d4f04bd6c77881bbe4c9ef5db7349d90.svg";